import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { t } from '../i18n/nl.js';

// F4-10 Stap 3 — publieke, niet-ingelogde bevestigingspagina waarnaar
// de klant na een iDEAL-betaling wordt teruggestuurd (redirectUrl).
// Puur informatief: leest via een publieke SECURITY DEFINER-RPC alleen
// een grove statuscategorie (paid/pending/failed/not_found) — GEEN
// factuurdetails. De daadwerkelijke statussynchronisatie gebeurt altijd
// via de mollie-webhook Edge Function, nooit via deze pagina.

const STATUS_STYLES = {
  paid:      { color: '#1d9e75', icon: '✓' },
  pending:   { color: '#f59e0b', icon: '…' },
  failed:    { color: '#dc2626', icon: '✕' },
  not_found: { color: '#6b7280', icon: '?' },
};

export default function BetalingBevestigingPage() {
  const { invoiceId } = useParams();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function loadStatus() {
      const { data, error } = await supabase.rpc('get_invoice_payment_status_public', {
        p_invoice_id: invoiceId,
      });
      if (cancelled) return;
      setStatus(error ? 'not_found' : (data || 'not_found'));
      setLoading(false);
    }
    loadStatus();
    return () => { cancelled = true; };
  }, [invoiceId]);

  const style = STATUS_STYLES[status] || STATUS_STYLES.pending;
  const messageKey = status === 'not_found' ? 'notFound' : (status || 'pending');

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f9fafb',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      padding: 20,
    }}>
      <div style={{
        background: 'white',
        borderRadius: 12,
        padding: '40px 32px',
        maxWidth: 420,
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      }}>
        <h1 style={{ fontSize: 20, marginBottom: 20, color: '#111827' }}>
          {t('betalingBevestiging.titel')}
        </h1>

        {loading ? (
          <p style={{ color: '#6b7280', fontSize: 14 }}>{t('betalingBevestiging.laden')}</p>
        ) : (
          <>
            <div style={{
              width: 56, height: 56, borderRadius: '50%',
              background: style.color, color: 'white',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 28, margin: '0 auto 20px',
            }}>
              {style.icon}
            </div>
            <p style={{ color: '#374151', fontSize: 15, lineHeight: 1.6 }}>
              {t(`betalingBevestiging.${messageKey}`)}
            </p>
            <p style={{ color: '#9ca3af', fontSize: 13, marginTop: 24 }}>
              {t('betalingBevestiging.terugNaarApp')}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
